import dayjs from "dayjs"


class TestTaker {

    constructor(testTaker, learningUnitType, learningUnit) {
        const { id, filled_fields, school_class, parent_first_name, parent_last_name, parent_phone, parent_email, gender, language, test_taker_name, test_taker_id, dob, affiliation, affiliation_name, tz, grade_name, grade, school_class_name, affiliation_institution_code, first_name, last_name } = testTaker

        this.first_name = first_name
        this.last_name = last_name
        this.full_name = test_taker_name
        this.tz = tz

        if (id || test_taker_id)
            this.test_taker_id = test_taker_id || id
        if (dob)
            this.dob = dayjs(new Date(dob))
        this.gender = gender
        this.language = language
        if (grade)
            this.home_grade = { id: grade, name: grade_name }
        if (school_class)
            this.home_class = { id: school_class, name: school_class_name }
        if (affiliation)
            this.home_affiliation = { id: affiliation, name: affiliation_name, institution_code: affiliation_institution_code }


        this.parent_email = parent_email
        this.parent_phone = parent_phone
        this.parent_first_name = parent_first_name
        this.parent_last_name = parent_last_name

        // שדות עבורינו כדי שנדע איזה סוג יישות מעדכנת את התלמיד
        if (learningUnitType)
            this.learningUnitType = learningUnitType
        if (learningUnit)
            this.learningUnit = learningUnit

        this.filled_fields = filled_fields
    }
}

export default TestTaker